const PROD_ENV = "production";
const DEV_ENV = "development";
const TEST_ENV = "test";

/** Safe env access for both Node (Jest) and browser (Vite uses import.meta.env). */
function getNodeEnv(): string | undefined {
  if (typeof process !== "undefined" && process.env?.NODE_ENV) {
    return process.env.NODE_ENV;
  }
  return import.meta.env.MODE;
}

function getCommitHash(): string | undefined {
  if (typeof process !== "undefined" && process.env?.COMMIT_HASH) {
    return process.env.COMMIT_HASH;
  }
  return import.meta.env.REACT_APP_COMMIT_HASH ?? import.meta.env.COMMIT_HASH;
}

function isProd(): boolean {
  return getNodeEnv() === PROD_ENV;
}

function isDev(): boolean {
  return getNodeEnv() === DEV_ENV;
}

function isTestEnv(): boolean {
  return getNodeEnv() === TEST_ENV;
}

function isProdRelease(): boolean {
  return isProd() && !!getRelease();
}

function getRelease(): string | undefined {
  return getCommitHash();
}

/** Undefined outside a Vite build (e.g. under Jest), where nothing defines it. */
function getAppVersion(): string {
  return typeof __APP_VERSION__ === "undefined" ? "dev" : __APP_VERSION__;
}

function printRelease(): void {
  console.log(
    `%cAptEdge release: ${getAppVersion()}`,
    "color: #06778c; font-weight: 900;"
  );
}

function inDevOnly(cb: () => void): void {
  if (isDev()) cb();
}

function inProdOnly(cb: () => void): void {
  if (isProd()) cb();
}

function inProdReleaseOnly(cb: () => void): void {
  if (isProdRelease()) cb();
}

export {
  getAppVersion,
  getRelease,
  inDevOnly,
  inProdOnly,
  inProdReleaseOnly,
  isDev,
  isProd,
  isProdRelease,
  isTestEnv,
  printRelease,
  PROD_ENV,
  DEV_ENV,
  TEST_ENV
};
